"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RiskHandlingBy = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.RiskHandlingBy = {
    priority: 1,
    label: 'fields.payload.mor_group_answers.risk_handling_by.label',
    fallbackLabel: 'How do you manage risk associated with your Distributors? Please elaborate on how your organization oversees and ensures that your Distributors comply with all necessary regulatory requirements, including licenses, AML & CTF and sanction obligations?',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_group_answers.entrust_other_contracted_entities', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.String,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return payload.mor_group_answers?.entrust_other_contracted_entities === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return payload.mor_group_answers?.entrust_other_contracted_entities === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
